// Конкурс «приведи друзів». Одне місце правди для бота і Mini App: поки активний —
// новачки бачать його в привітанні /start, усі — банер на головній. Після END
// усе зникає само, без деплою. Підсумки рахує scripts/contest_results.py.
export const CONTEST = {
  start: new Date('2026-09-14T00:00:00+03:00'),
  // СКАСОВАНО 25.09.2026: за 11 днів 2 учасники / 4 друзі — сенсу нема. end у минулому
  // вимикає банер на Home, блок у /start і блок на сторінці друзів без інших правок.
  end: new Date('2026-09-24T23:59:59+03:00'),
  endLabel: '28 вересня',
  resultsLabel: '29 вересня',
  prizeTop: 'Telegram Premium на 3 місяці',
  prizeDraw: '3 × Premium у Тестах ПДР на 1 місяць',
} as const;

export function isContestActive(now: Date = new Date()): boolean {
  return now >= CONTEST.start && now <= CONTEST.end;
}
